import { fetchApi } from '@app/hooks/api';

export interface AgentDto {
  id: string;
  name: string;
  description: string | null;
  icon: string | null;
  color: string | null;
  sdlcGroup: string;
  mode: 'portal-chat' | 'external-link' | 'planned';
  capabilities: string[] | null;
  tools: string[] | null;
  toolCount: number | null;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
  externalUrl?: string | null;
  endpoints?: {
    chatUrl?: string;
    chatStreamUrl?: string;
    promptsUrl?: string;
    modelsUrl?: string;
  } | null;
}

export interface AgentFilters {
  mode?: 'portal-chat' | 'external-link' | 'planned';
  sdlcGroup?: string;
}

export async function fetchAgents(
  getToken: () => Promise<string>,
  filters: AgentFilters = {},
): Promise<AgentDto[]> {
  const params = new URLSearchParams();
  if (filters.mode) params.set('mode', filters.mode);
  if (filters.sdlcGroup) params.set('sdlcGroup', filters.sdlcGroup);
  const qs = params.toString();
  return fetchApi<AgentDto[]>(`/api/agents${qs ? `?${qs}` : ''}`, getToken);
}

export async function fetchAgent(
  getToken: () => Promise<string>,
  id: string,
): Promise<AgentDto> {
  return fetchApi<AgentDto>(`/api/agents/${encodeURIComponent(id)}`, getToken);
}
